import { ExternalUserCreateDto, type ExternalUserCreateInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-create.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

/** External user create request body for personal account mode - DTO signature */
export type ExternalUserLkCreateInterface = Omit<ExternalUserCreateInterface, 'isMailingEnabled' | 'client' | 'contragents'>

/** External user create request body for personal account mode - DTO schema */
export const ExternalUserLkCreateDto = SerdeDtoClass.omit(
  SecurityDtoKeysEnum.EXTERNAL_USER_LK_CREATE_DTO,
  ExternalUserCreateDto,
  ['isMailingEnabled', 'client', 'contragents'],
);
